var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"name":"header"}}),_c('router-view',{key:_vm.defaultViewKey,staticClass:"content",class:{'is-loading': _vm.isLoading }}),_c('router-view',{attrs:{"name":"footer"}}),_c('loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }